import React from 'react';
import TwTooltip from '../TwTooltip/TwTooltip';
import Box from '@mui/material/Box';
import TwBadge from '../TwBadge/TwBadge';
import { SxProps } from '@mui/material/styles';

const TwEdiBadge: React.FC<{ sxProps?: SxProps }> = ({ sxProps }) => {
  const message = 'EDI imported, status updates are enabled';
  return (
    <TwTooltip title={message} placement="top">
      <Box component="span" sx={{ display: 'flex' }}>
        <TwBadge
          content="EDI"
          variant="warning"
          sx={{ display: 'flex', alignItems: 'center', ...sxProps }}
        />
      </Box>
    </TwTooltip>
  );
};

export default TwEdiBadge;
